var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"page-header-chat",class:[_vm.data.class, _vm.data.staticClass]},[_c('a',{attrs:{"href":_vm.props.chatUrl},on:{"click":function($event){$event.preventDefault();return _vm.listeners.chat($event)}}},[_vm._v("Chat")])])}
var staticRenderFns = []

export { render, staticRenderFns }